registerComponent("sections/wa-faq", function (component) {
/**
 * sections/wa-faq — as perguntas frequentes.
 *
 * ABRIR E FECHAR É DO HTML, não deste script: cada pergunta é um
 * `<details>`/`<summary>`, que já traz teclado, estado anunciado e — o que
 * decide — funciona SEM JS. Numa página cujo conteúdo de segurança (o número
 * oficial, o que o ASA nunca pede pelo WhatsApp) está dentro das respostas,
 * deixar isso depender de script seria errado. Ver o cabeçalho do HTML.
 *
 * Sobra a entrada das peças (`.entrada`, `_entrada.less` / ADR 0051).
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

if (Asa.movimentoPermitido()) {
    Asa.armarEntrada([component], '.entrada');
}

});
